<script>
    import { onMount } from 'svelte';
    import XmasGame from './game-1.svelte'
    import Error500 from './error-500.svelte'
    import Expired from './error-expired.svelte'
    import SubmissionError from './error-entered.svelte'
    import { memberStore } from '../../store.js';
    import Loader from '../widgets/loader.svelte'
    import Header from '../global/header.svelte';
      import Footer from '../global/footer.svelte';


    /**
     * Globals
    */
    let comp_assets;
    let comp_title;
    let comp_content;
    let comp_terms;
    let comp_spread;
    let comp_button;


    /**
     * The x translation of the star while it's being dragged.
     * @type {Number}
     */
    let gameDay = 0;

    /**
     * The size of the graphical element being dragged
     * @type {Number}
     */
    let targetW = "12vh";

    /**
     * The x translation of the star while it's being dragged.
     * @type {Number}
     */
    let targetH = "12vh";

    /**
    * Has the user entered todays drawer already
    * @type {Boolean}
    */
    let hasEnteredToday = false;

    /**
    * Is there an issue with the server?
    * @type {Boolean}
    */
    let serverError = false;

    /**
    * Is there an issue with the server?
    * @type {Boolean}
    */
    let expiredPromo = false;

    /**
     * The user object from the store
     * @type {Object}
     */
    let user;


    /**
    * Has the user entered todays drawer already
    * @type {Boolean}
    */
    let preLaunchClicked = false;

     /**
     * Indicates that page is loading
     */
    let loading = true;

    memberStore.subscribe(member => {
        user = member
    });

    function startGameUI( ) {
        preLaunchClicked = true;

/*
        if( gameDay == 1 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk//1-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk//1-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk//1-target.svg";
        }

        if( gameDay == 2 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk/2-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk/2-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk/2-target.svg";
        }

        if( gameDay == 3 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk/3-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk/3-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk/3-target.svg";
        }

        if( gameDay == 4 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk/4-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk/4-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk/4-target.svg";
        }

        if( gameDay == 5 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk/5-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk/5-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk/5-target.svg";
        }

        if( gameDay == 6 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk/1-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk/1-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk/1-target.svg";
        }

        if( gameDay == 7 ) {
            comp_assets.scene_default = "https://assets.southernco-op.co.uk/3-scene.svg";
            comp_assets.scene_complete = "https://assets.southernco-op.co.uk/3-finish.svg";
            comp_assets.sprite = "https://assets.southernco-op.co.uk/3-target.svg";
        }
        */

    }


    onMount(async () => {
        
        
       
        let formData = new FormData();
        formData.append('number', user.number);
        formData.append('zip', localStorage.getItem('zip') );

       
        fetch("https://api.southernco-op.co.uk/member/fetchPromoDayNew", {
            headers: {
                'Accept': 'application/json',
            },
            method: "POST",
            body: formData
        })
        .then( response => response.json() )
        .then( data => {         

            loading = false;
            
            if( data.error ) {

             
            
                if( data.error == "PROMO_EXPIRED") {
                    expiredPromo = true;
                    comp_title = data.data.title;
                    comp_terms = data.data.terms_url;
                    comp_spread = data.data.date_spread;
                }
                if( data.error == "SQL_ERROR") {
                    serverError = true;
                }
                if( data.error == "DUPLIACTE_ENTRY") {
                    hasEnteredToday = true;
                    comp_title = data.data.title;
                    comp_terms = data.data.terms_url;
                    comp_spread = data.data.date_spread;
                }
                if( data.error == "NOT_STARTED") {
                    expiredPromo = true;
                    comp_title = data.data.title;
                    comp_terms = data.data.terms_url;
                    comp_spread = data.data.date_spread;
                }

            

            } else {
         
                let day = data.day;

                 comp_assets = data.comp_data;

                 comp_title = data.details.title;
                 comp_content = data.details.content;
                 comp_terms = data.details.terms_url;
                 comp_spread = data.details.date_spread;
                 comp_button = data.details.button_url;
        
                gameDay = day;
                        
            }

        } )                
        .catch( err => {
            loading = false;
            serverError = true;
        }); 
        
    
});

</script> 

<style>

    .prelaunch h1 {
        font-size:22px;
        font-size: 2.2rem;
        line-height: 27px;
        font-weight: 300;
         text-align: center;
         color: var(--brand-color);
    }

    .prelaunch > div {
        padding: 5vw;
        min-height: 60vh;
        display: flex;
        align-items: center;
        justify-content: center; 
        text-align: left;
    }

    :global(.prelaunch ul li) {
        list-style: disc;
        margin-left: 1em;
        margin-bottom: 5px
    }

     .prelaunch .btn {
        background: var(--brand-color);
        color: var(--dark-color);
        text-align: center;
        border: none;
        border-radius: 25px;
        font-size: 18px;
        padding: 10px 25px;
        font-weight: 600;
        margin: 15px auto 0 auto;
     
    }

    


</style>


<svelte:head>
    <title>Competition</title>
</svelte:head>

<div>
    {#if !loading}
        {#if !serverError}
            {#if !expiredPromo}
                {#if !hasEnteredToday}
                    {#if preLaunchClicked }
                        {#if gameDay}
                            <XmasGame targetW={targetW} targetH={targetH} gameDay={gameDay} stageImageURL={comp_assets.scene_default} finishImageURL={comp_assets.scene_complete} spriteImageURL={comp_assets.sprite} prizeImageURL={comp_assets.prize} compSpread={comp_spread} termsURL={comp_terms} />
                        {/if}
                    {:else}
                    <Header title="Competition" url="/" /> 

                        <section class="prelaunch">
                            <div>
                                <div>
                                    
                                  

                                    {#if comp_button}
                                    <img src="{comp_button}" alt="Competition" on:click|once={startGameUI} />
                                    {/if}
                                    <h1>{comp_title}</h1>
                                    {@html comp_content}
                                    
                                    <button class="btn" on:click|once={ () => { startGameUI(); }}>Start Game</button> 
                                    <!-- 
                                    <button class="btn" on:click|once={ () => { gameDay = 2; startGameUI(); }}>Start Game 2</button> 
                                    <button class="btn" on:click|once={ () => { gameDay = 3; startGameUI(); }}>Start Game 3</button> 
                                    <button class="btn" on:click|once={ () => { gameDay = 4; startGameUI(); }}>Start Game 4</button> 
                                    <button class="btn" on:click|once={ () => { gameDay = 5; startGameUI(); }}>Start Game 5</button>
                                    <button class="btn" on:click|once={ () => { gameDay = 6; startGameUI(); }}>Start Game 6</button>
                                    <button class="btn" on:click|once={ () => { gameDay = 7; startGameUI(); }}>Start Game 7</button>
                                    -->

                                    <p><small>For full terms and conditions visit: <a target="_blank"  href={comp_terms}>{comp_terms}</a></small></p>
  
                                </div>
                            </div>
                        </section>

                    <Footer />                        
                       
                    {/if}
                {:else}
                    <SubmissionError compTitle={comp_title} compSpread={comp_spread} termsURL={comp_terms} />
                {/if}
            {:else}
                <Expired compTitle={comp_title} compSpread={comp_spread} termsURL={comp_terms} />
            {/if}   
        {:else}
            {#if expiredPromo}
                <Expired compTitle={comp_title} compSpread={comp_spread} termsURL={comp_terms} />
            {:else}
                <Error500 />
            {/if}   
            
        {/if}
    {:else}
        <Header title="Day {gameDay}" url="/" /> 
        <Loader msg="Please wait!" />
    {/if}
 </div>

